import BaseBtModal from "../../BaseBtModal.vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { defineComponent } from "vue";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
//@ts-ignore
import { Modals as _Modals } from "@customTypes/Modals";
export default defineComponent({
  name: "UnauthorizedModal",
  components: {
    BaseBtModal: BaseBtModal,
    BaseAlert: BaseAlert,
    BaseButton: BaseButton
  },
  props: {
    showModal: {
      type: Boolean,
      "default": false
    },
    labels: {
      type: Object,
      required: true
    }
  },
  emits: ["open-login-modal", "closed", "opened"],
  setup: function setup() {
    var _useModalStore = useModalStore(),
      setShowModal = _useModalStore.setShowModal;
    return {
      setShowModal: setShowModal
    };
  },
  computed: {
    Modals: function Modals() {
      return _Modals;
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit("open-login-modal");
    },
    onClosed: function onClosed() {
      this.$emit("closed");
    },
    onOpened: function onOpened() {
      this.$emit("opened");
    }
  }
});